import React, { useCallback, useState } from 'react';
import { ZAvatar, useApiClient } from '@marageti/z4-lib';
import { Partner } from '@marageti/z4-sdk/lib/travel';
import { enqueueSnackbar } from 'notistack';

type PartnerAvatarProps = {
  partner: Partner | undefined;
  onPartnerUpdate: (updatedPartner: Partner) => void;
};

const PartnerAvatar = ({ partner, onPartnerUpdate }: PartnerAvatarProps) => {
  const [avatarLoading, setIsAvatarLoading] = useState<boolean>(false);
  const apiClient = useApiClient();
  const { id: partnerId, name, avatar } = partner || {};

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onUpdateAvatar = useCallback(
    async (base64Img: string) => {
      try {
        if (!partnerId) return;
        setIsAvatarLoading(true);
        const updatedPartner = await apiClient.partnersClient.putPartnerAvatar(
          partnerId,
          { id: partnerId, avatar: base64Img },
        );
        onPartnerUpdate(updatedPartner);
      } catch (error: any) {
        // eslint-disable-next-line no-console
        console.error('Error updating avatar:', error);
        enqueueSnackbar('The image could not be uploaded', { variant: 'default' });
      } finally {
        setIsAvatarLoading(false);
      }
    },
    [partnerId, apiClient, setIsAvatarLoading],
  );

  return (
    <ZAvatar
      src={avatar}
      loading={!partnerId || avatarLoading}
      size={128}
      alt={name}
      name={name}
      onEdit={onUpdateAvatar}
    />
  );
};

export default PartnerAvatar;
